<template>
      <b-container class="destinations">
      <section>
        <div class="main_title">
          <h1 class="text-center">
            <strong>العروض الخاصة</strong>
          من اجازة بوك
          </h1>
          <UnderLine/>
        </div>
        <EgyptDestinations/>
        <hr/>
        <WorldDestinations/>
      </section>
    </b-container>
</template>
<script type="text/javascript">
  import UnderLine   from '../global/UnderLine'
  import EgyptDestinations from './EgyptDestinations'
  import WorldDestinations from './WorldDestinations'
  export default {
    name:'Destinations',
    components: {
      UnderLine,
      EgyptDestinations,
      WorldDestinations
    }
  }
</script>
